import React from 'react';
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import { useMemo } from 'react';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Filler);

const AdminDashboardCharts = ({ agreements, users, financialLog }) => {
    // Gráfico Circular (Sin cambios, ya funciona bien)
    // CORRECCIÓN: Añadir un fallback a un array vacío para evitar errores si 'agreements' es undefined durante la carga.
    const statusCounts = (agreements || []).reduce((acc, a) => {
        acc[a.status] = (acc[a.status] || 0) + 1;
        return acc;
    }, {});
    const doughnutData = {
        labels: ['Aprobados', 'Pendientes', 'Rechazados', 'Completados'],
        datasets: [{
            data: [statusCounts.aprobado || 0, statusCounts.pendiente || 0, statusCounts.rechazado || 0, statusCounts.completado || 0],
            backgroundColor: ['#22c55e', '#f59e0b', '#ef4444', '#3b82f6'],
            borderColor: '#ffffff',
            borderWidth: 2,
        }],
    };
    const doughnutOptions = {
        responsive: true, maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'Estado de Acuerdos' }
        }
    };

    // --- INICIO DE LA MEJORA: Gráfico de Barras de Inversión por Mes ---
    const investmentByMonthData = useMemo(() => {
        const monthlyData = {};

        (agreements || [])
            .filter(a => a.status === 'aprobado' && !a.isTest)
            .forEach(agreement => {
                if (agreement.approvedAt && agreement.approvedAt.toDate) {
                    const date = agreement.approvedAt.toDate();
                    const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                    
                    if (!monthlyData[monthKey]) {
                        monthlyData[monthKey] = 0;
                    }
                    monthlyData[monthKey] += agreement.netInvestmentAmount || agreement.amount || 0;
                }
            });

        const sortedMonths = Object.keys(monthlyData).sort();

        const labels = sortedMonths.map(monthKey => {
            const [year, month] = monthKey.split('-');
            return new Date(year, month - 1).toLocaleString('es-ES', { month: 'short', year: 'numeric' });
        });

        const data = sortedMonths.map(monthKey => monthlyData[monthKey]);

        return {
            labels,
            datasets: [{
                label: 'Capital Invertido por Mes ($)',
                data: data,
                backgroundColor: 'rgba(44, 94, 78, 0.6)',
                borderColor: 'rgba(44, 94, 78, 1)',
                borderWidth: 1,
            }],
        };
    }, [agreements]);

    const investmentByMonthOptions = {
        responsive: true, maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'Evolución del Capital Invertido (Real)', font: { size: 16 } }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: { callback: (value) => '$' + value.toLocaleString() }
            }
        }
    };
    // --- FIN DE LA MEJORA ---

    // --- INICIO DE LA MEJORA: Gráfico de Barras de Nuevos Usuarios por Mes ---
    const usersByMonthData = useMemo(() => {
        const monthlyData = {};

        (users || []).forEach(user => {
            if (user.createdAt && user.createdAt.toDate) {
                const date = user.createdAt.toDate();
                const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
                
                if (!monthlyData[monthKey]) {
                    monthlyData[monthKey] = 0;
                }
                monthlyData[monthKey]++;
            }
        });

        const sortedMonths = Object.keys(monthlyData).sort();

        const labels = sortedMonths.map(monthKey => {
            const [year, month] = monthKey.split('-');
            return new Date(year, month - 1).toLocaleString('es-ES', { month: 'long', year: 'numeric' });
        });

        const data = sortedMonths.map(monthKey => monthlyData[monthKey]);

        return {
            labels,
            datasets: [{
                label: 'Nuevos Usuarios por Mes',
                data: data,
                backgroundColor: 'rgba(147, 51, 234, 0.6)', // Púrpura con transparencia
                borderColor: 'rgba(147, 51, 234, 1)',
                borderWidth: 1,
            }],
        };
    }, [users]);

    const usersByMonthOptions = {
        responsive: true, maintainAspectRatio: false,
        plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'Adquisición de Nuevos Usuarios por Mes', font: { size: 16 } }
        },
        scales: {
            y: { ticks: { stepSize: 1 } }
        }
    };

    return (
        <div className="dashboard-charts-grid">
            <div className="chart-card"><Doughnut data={doughnutData} options={doughnutOptions} /></div>            
            <div className="chart-card"><Bar data={investmentByMonthData} options={investmentByMonthOptions} /></div>
            <div className="chart-card full-width"><Bar data={usersByMonthData} options={usersByMonthOptions} /></div>
        </div>
    );
};

export default AdminDashboardCharts;